module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAOhJREFUWEftlNERwUAYhHcroAQdoAI6QAdUQAfoQCqghKQDKhAd0IEO1vwzZybOJbyQl/+eMne3szvfvzmi5cWW/eEBnIATcAJO4IWApC7J+y+f59iDtgFgDWAVjI8AFiSvdUGCZg9gGu7kQVMbXlIPgGnGQbMDsLUA9rGMzEqSw4YAZjiJznOSswZNCaAfnWcWwFJ3EsIhSRO9LUlK7ZNMllrSAMA5obm2HeBWN4ILSUudXJJSIyhIPjuRolY7AivhptKDE4D5FyU8VHpQBM2nEppmFNJl5vv33zBG4y+hE3ACTsAJOIEHXw1nDuCE8mcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/other-contract.png
// module id = 3W56
// module chunks = 41